import { render, staticRenderFns } from "./FullBox.vue?vue&type=template&id=591837de"
import script from "./FullBox.vue?vue&type=script&lang=js"
export * from "./FullBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports